/**
 * P2-04 · The card's public surface.
 *
 * P18-19 · Every module behind it is either hook-free (`./product-card`,
 * `./derive`, `./price-display`, `./skeleton`) or a `"use client"` island, and
 * none of them imports `server-only` — so a server component and a client
 * island can both import from here, and the shell renders on whichever side its
 * caller is on.
 */
export { ProductCard, type ProductCardProps } from "./product-card";
export { ProductCardSkeleton } from "./skeleton";
export { PriceDisplay } from "./price-display";
export {
  cardAccessibleName,
  deriveCardStatus,
  hasPriceRange,
  type CardStatus,
} from "./derive";
export type {
  ProductCardView,
  ProductCardViewImage,
  ProductCardViewSwatch,
} from "./types";
